import {ViewerSettingThemeType} from '../../../../../../design-system/organisms/ViewerSetting/ViewerSettingThemeItemType.interface';

export function getTextViewerThemeColorSet(theme: ViewerSettingThemeType) {
  switch (theme) {
    case 'Black': {
      return {
        bg: 'rgb(var(--colors-viewer-static-epub-black-bg))',
        text: 'rgb(var(--colors-viewer-static-epub-black-text))',
        isDark: true,
      };
    }
    case 'DarkGray': {
      return {
        bg: 'rgb(var(--colors-viewer-static-epub-darkgray-bg))',
        text: 'rgb(var(--colors-viewer-static-epub-darkgray-text))',
        isDark: true,
      };
    }
    case 'LightGray': {
      return {
        bg: 'rgb(var(--colors-viewer-static-epub-lightgray-bg))',
        text: 'rgb(var(--colors-viewer-static-epub-lightgray-text))',
        isDark: false,
      };
    }
    case 'Green': {
      return {
        bg: 'rgb(var(--colors-viewer-static-epub-green-bg))',
        text: 'rgb(var(--colors-viewer-static-epub-green-text))',
        isDark: true,
      };
    }
    case 'Sepia': {
      return {
        bg: 'rgb(var(--colors-viewer-static-epub-sepia-bg))',
        text: 'rgb(var(--colors-viewer-static-epub-sepia-text))',
        isDark: false,
      };
    }
    case 'White': {
      return {
        bg: 'rgb(var(--colors-viewer-static-epub-white-bg))',
        text: 'rgb(var(--colors-viewer-static-epub-white-text))',
        isDark: false,
      };
    }
  }
}
